import { GameMode } from '../types';
import type { ModeDescription } from './types';

export const INFINITE_SCORE_MODE: ModeDescription = {
  mode: GameMode.INFINITE_SCORE,
  title: 'Endless Score',
  description: 'Score = Correct - Wrong. Play until you run out of countries.',
  icon: '💯',
};
